export const specialCharactersRegex = /[.*+?^${}()|[\]\\]/gu;
export const numbersRegex = /[0-9,.]/u;
